<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<div class="content-heading">
	<h3>{{locoLabel?.assignment|uppercase}}</h3>
</div>
<table class="table table-no-border loco-assignment-table two-col-tbl">
	<tbody>
		<tr>
			<td class="current-assign">{{locoLabel?.assignCurrent}} {{locoLabel?.assignment}}</td>
			<td>{{locoData?.currentAssignment|locoBlankString}}
				<span *ngIf="qualifierValue"><br/>{{qualifierValue}}</span>
			</td>
		</tr>
		<tr>
			<td>{{locoLabel?.terminalHandlingPlan}}</td>
			<td *ngIf="!returnDash([locoData?.thpType,locoData?.thpTerminal])">{{locoData?.thpTerminal}} {{locoData?.thpType}}</td>
			<td *ngIf="returnDash([locoData?.thpType,locoData?.thpTerminal])">-</td>
		</tr>
		<tr>
			<td>{{locoLabel?.assignPlanned}} {{locoLabel?.assignment}}</td>
			<td>{{getPlannedAssignmentValue(locoData)}}</td>
		</tr>
		<tr>
			<td class="intended-usage-label">{{locoLabel?.intendedUsage}}</td>
			<td><span class="{{intendedUsageCode === 'NP' ? 'color-red':''}}">{{intendedUsageValue}}</span>
				<span *ngIf="intendedUsageReason"><br/>{{intendedUsageReason}}</span>
				<span *ngIf="intendedUsageNote" class="loco-iu-notes"><br/>{{intendedUsageNote}}</span>
			</td>
		</tr>
		<tr>
			<td>{{locoLabel?.assignPrevious}} {{locoLabel?.assignment}}</td>
			<td>{{locoData?.previousAssignment|locoBlankString}}</td>
		</tr>
	</tbody>
</table>